import { useEffect, useState } from "react";
import { apiFetch } from "./api";
import { modulosDelMenu } from "./menu";

// Temas de color que elige el administrador en Parámetros. Las claves deben coincidir con
// backend/routes/apariencia.js. Cada color se vuelve una variable CSS (--tema-...) que usa TemaDetalle.
export const TEMAS = [
  {
    clave: "institucional",
    nombre: "Institucional",
    descripcion: "Azul y dorado del colegio.",
    colores: { primario: "#1f4e96", titulo: "#0b3c60", franja: "#0b3c60", acento: "#fec900", suave: "#eef3fa", linea: "#d5deec", franjaTexto: "#ffffff", franjaSub: "#c7d0e0", enlace: "#ffe28a" },
  },
  {
    clave: "clasico",
    nombre: "Clásico",
    descripcion: "Claro y sencillo, con poco color.",
    colores: { primario: "#4a6484", titulo: "#0b3c60", franja: "#ffffff", acento: "#8fa3c2", suave: "#f4f6f8", linea: "#d3d9df", franjaTexto: "#0b3c60", franjaSub: "#5b6472", enlace: "#2f6690" },
  },
  {
    clave: "esmeralda",
    nombre: "Esmeralda",
    descripcion: "Verde profundo con dorado.",
    colores: { primario: "#1b7a5a", titulo: "#0f4c3a", franja: "#0f4c3a", acento: "#f2c14e", suave: "#ecf6f1", linea: "#cfe3d9", franjaTexto: "#ffffff", franjaSub: "#c5ddd1", enlace: "#ffe28a" },
  },
  {
    clave: "vino",
    nombre: "Vino",
    descripcion: "Tinto elegante con dorado.",
    colores: { primario: "#8a2a44", titulo: "#5a1a2b", franja: "#5a1a2b", acento: "#e8b04a", suave: "#f8eef1", linea: "#e8d3da", franjaTexto: "#ffffff", franjaSub: "#e3c9d1", enlace: "#ffe2a8" },
  },
];

// Secciones del sistema a las que se les puede aplicar el tema: salen del menú lateral
// (utils/menu.js), así una pantalla nueva del menú aparece sola en "Aplicar en".
// "menu" no es una pantalla: es el menú lateral y la barra de arriba.
export const MODULOS = modulosDelMenu();

const DEFECTO = { tema: "institucional", modulos: MODULOS.map((m) => m.clave) };

const nombreVariable = (color) => `--tema-${color}`;

// Colores del tema como variables CSS, para ponerlas en el contenedor de la pantalla.
export function variablesTema(clave) {
  const tema = TEMAS.find((t) => t.clave === clave) || TEMAS[0];
  return Object.fromEntries(Object.entries(tema.colores).map(([color, valor]) => [nombreVariable(color), valor]));
}

// Variables del menú lateral y la barra de arriba.
export const variablesMenu = (apariencia) =>
  variablesTema(apariencia.modulos.includes("menu") ? apariencia.tema : "institucional");

// Variables para una ruta: el tema elegido si el módulo está marcado; si no, el institucional.
export function variablesDeRuta(pathname, apariencia) {
  const modulo = MODULOS.find((m) => m.rutas.some((r) => pathname === r || pathname.startsWith(`${r}/`)));
  const aplica = modulo && apariencia.modulos.includes(modulo.clave);
  return variablesTema(aplica ? apariencia.tema : "institucional");
}

let apariencia = { ...DEFECTO };
let cargada = false;
const oyentes = new Set();

export async function cargarApariencia() {
  try {
    const datos = await apiFetch("/api/apariencia");
    if (datos) apariencia = datos;
    cargada = true;
    oyentes.forEach((avisar) => avisar());
  } catch {
    // Sin conexión: se sigue con el tema de siempre.
  }
}

export function useApariencia() {
  const [, repintar] = useState(0);
  useEffect(() => {
    const avisar = () => repintar((n) => n + 1);
    oyentes.add(avisar);
    if (!cargada) cargarApariencia();
    return () => oyentes.delete(avisar);
  }, []);
  return apariencia;
}
